// import {defineCliConfig} from 'sanity/cli'
import {createClient} from '@sanity/client'

export const client = createClient({
    projectId: 'fsyqboh0',
    dataset: 'production',
    useCdn: true,
    apiVersion: '2023-05-03'
});
